import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const APP_ROLE_DELETE_RESOURCE = "app-role" as const;
export const APP_ROLE_DELETE_API_PATH = `/v1/${APP_ROLE_DELETE_RESOURCE}/{uuid}` as const;

export type AppRoleDeleteResponse =
  paths[typeof APP_ROLE_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useAppRoleDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AppRoleDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<AppRoleDeleteResponse>(`/v1/${APP_ROLE_DELETE_RESOURCE}/${uuid}`);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [APP_ROLE_DELETE_RESOURCE],
      });
    },
  });
};
